import { useEffect, useState } from "react";
import api from "./api";
import { readCache, writeCache } from "./cache";

let mem = null;
let inflight = null;

export const fetchFamilies = () => {
  if (!inflight) {
    inflight = api.get("/families")
      .then((r) => { mem = r.data || []; writeCache("cs_families", mem); return mem; })
      .catch(() => { inflight = null; return mem || readCache("cs_families") || []; });
  }
  return inflight;
};

export function useFamilies() {
  const [list, setList] = useState(() => mem || readCache("cs_families"));
  const [loaded, setLoaded] = useState(!!mem);
  useEffect(() => { fetchFamilies().then((f) => { setList(f); setLoaded(true); }); }, []);
  return [list || [], loaded];
}
